import * as React from 'react';
import * as Images from 'pos/Images';

import { Preconditions } from 'core/infrastructure-next';
import { AuditEventDTO, Res, Permission } from 'core/api';
import { Command } from 'pos/common';
import { asTime } from 'core/ui/controls/Format';
import { AuditFacade } from 'pos/facades';
import { Cols, Col, Flex } from 'core/ui';
import { Modal } from 'core/ui-next/modal';
import { ActionButtonDefinition, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';

type Props = {
	events: AuditEventDTO[]
} & Modal.Actions<void>;


class TicketAuditory extends PosStatelessScreenClassComponent<Props> {

	protected getScreenId(): string {
		return 'TICKET_AUDITORY';
	}

	protected getTitle(): string {
		return Res.Web.SHOW_TICKET_AUDITORY_TITLE();
	}

	protected getImage(): string | SvgIcon {
		return Images.ViewTicketAuditory;
	}

	protected useKeypad() {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {
		const lines = this.props.events.map(e => {
			return <li key={e.Id}>
				<Cols>
					<Col width='8ex'>
						{asTime(e.Time)}
					</Col>
					<Col width='10ex'>
						{e.UserName}
					</Col>
					<Col width='*'>
						<p>{e.Action}</p>
					</Col>
				</Cols>
			</li>;
		});

		return <Flex.Vertical>
			<Flex.Item>
				<Cols className='list-header'>
					<Col width='8ex' className='text-left'>
						{Res.Web.SHOW_TICKET_AUDITORY_TIME_CLM()}
					</Col>
					<Col width='10ex' className='text-left'>
						{Res.Web.SHOW_TICKET_AUDITORY_USER_CLM()}
					</Col>
					<Col width='*' className='text-left'>
						{Res.Web.SHOW_TICKET_AUDITORY_ACTION_CLM()}
					</Col>
				</Cols>
			</Flex.Item>
			<Flex.Item size='*'>
				<ul className='list'>
					{lines}
				</ul>
			</Flex.Item>
		</Flex.Vertical>;
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}
}

declare global {
	interface CommandType {
		viewTicketAuditory: (ticketGlobalId: string) => Promise<Result>
	}
}

Command.register('viewTicketAuditory', Preconditions.and(Preconditions.ensure(Permission.Ticket_ShowAuditory), Preconditions.ensureIsNotLite), async (ticketGlobalId: string): Promise<Result> => {
	const events = await AuditFacade.getEventsForTicket(ticketGlobalId);
	return await Modal.show(TicketAuditory, { events });
});